import { render, staticRenderFns } from "./createScore.vue?vue&type=template&id=26d46a64&scoped=true"
import script from "./createScore.vue?vue&type=script&lang=js"
export * from "./createScore.vue?vue&type=script&lang=js"
import style0 from "./createScore.vue?vue&type=style&index=0&id=26d46a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d46a64",
  null
  
)

export default component.exports